var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-block",
    {
      attrs: { title: "Themes Pages Table", "header-bg": "" },
      scopedSlots: _vm._u([
        {
          key: "options",
          fn: function () {
            return [
              _c(
                "b-button",
                {
                  attrs: { type: "submit", size: "sm", variant: "primary" },
                  on: { click: _vm.toggleNewPage },
                },
                [_vm._v("\n\t\t\tCreate new page\n\t\t")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { type: "submit", size: "sm", variant: "primary" },
                  on: { click: _vm.toggleExistingPage },
                },
                [_vm._v("\n\t\t\tAdd existing Pages\n\t\t")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showNewPage,
                  expression: "showNewPage",
                },
              ],
              attrs: { lg: "12" },
            },
            [
              _c(
                "div",
                { staticClass: "d-block text-left" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "form-group",
                      attrs: { label: "Name", "label-for": "block-form1-name" },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.themedata.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.themedata, "name", $$v)
                          },
                          expression: "themedata.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "form-group",
                      attrs: {
                        label: "Serialnumber",
                        "label-for": "block-form1-name",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.themedata.serialnumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.themedata, "serialnumber", $$v)
                          },
                          expression: "themedata.serialnumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3 mb-2",
                      on: {
                        click: function ($event) {
                          return _vm.addPage()
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\tAdd page\n\t\t\t\t")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showExistingPage,
                  expression: "showExistingPage",
                },
              ],
              attrs: { lg: "12" },
            },
            [
              _c(
                "div",
                { staticClass: "d-block text-left" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { "label-for": "example-select" } },
                    [
                      _c(
                        "b-form-select",
                        {
                          staticClass: "mb-2",
                          attrs: { id: "example-select", plain: "" },
                          model: {
                            value: _vm.ExistingPagesData,
                            callback: function ($$v) {
                              _vm.ExistingPagesData = $$v
                            },
                            expression: "ExistingPagesData",
                          },
                        },
                        [
                          _c("b-form-select-option", { attrs: { value: "" } }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\tPlease select an option\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.themepageDate, function (theme, id) {
                            return _c(
                              "b-form-select-option",
                              { key: id, attrs: { value: theme } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(theme.name) +
                                    "\n\t\t\t\t\t\t"
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3 mb-2",
                      on: {
                        click: function ($event) {
                          return _vm.addPages()
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\tAdd Page(s)\n\t\t\t\t")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { ref: "ThemesPagesTable" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }